/**
 * Shuffles the given array in-place; meaning, the given array will be mutated.
 * @param array The array to shuffle
 * @returns The shuffled array
 */
export function shuffleArray<T>(array: T[]): T[] {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1))
		;[array[i], array[j]] = [array[j], array[i]]
	}

	return array
}

export const padArray = <T>(array: T[], length: number): T[] => {
	const out = new Array<T>(length).fill(null as unknown as T)
	for (let i = 0; i < length; i++) {
		out[i] = array[i % array.length]
	}
	return out
}
